import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=db891c86&scoped=true&"
import script from "./DownloadApp.vue?vue&type=script&lang=js&"
export * from "./DownloadApp.vue?vue&type=script&lang=js&"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=db891c86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db891c86",
  null
  
)

export default component.exports